export class ResetPasswordDto {
    public uid: String;
    public token: String;
    public new_password: String;

    constructor(
        uid: String,
        token: String,
        new_password: String
    ) {
        this.uid = uid;
        this.token = token;
        this.new_password = new_password;
    }
}